module.exports = __webpack_public_path__ + "static/img/28ok.e419b8e2.webp";